import { isStandaloneApp } from "../../pwa/browserDisplayMode";
import { STAGE } from "../../stage";
import { parkOpensV2, readInterfacePolicy } from "./interfaceVersionPolicy";
import { isResearchGuestProfile } from "../../utils/users/researchGuest";

/** Bundle construit pour le staging (aws-stage), cf. scripts/start-env.js et deployStage.js. */
export const isStagingRuntime = (stage = STAGE) => stage === "stage";

/**
 * Accès V2 : tout profil dans l’application installée, le staff AKONGO partout,
 * tout utilisateur authentifié sur le
 * staging (recette avec de vrais profils de parc, décision du 2026-09-13),
 * et les membres d'un parc qu'AKONGO a ouvert à la V2 — en migration
 * (`choice`) ou définitivement (`v2`), cf. `interfaceVersionPolicy`.
 */
export const canOpenV2 = ({ viewer, stage, zooOptions, standalone = isStandaloneApp() } = {}) => (
  viewer?.akongoStaff === true
  // Invité recherche (sans parc) : ses projets n'existent qu'en V2.
  || isResearchGuestProfile(viewer)
  || (standalone && Boolean(viewer))
  || isStagingRuntime(stage)
  || parkOpensV2(readInterfacePolicy(zooOptions))
);
